export const ESPN_HEROS_BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates/ESPN-heros/football`;

export const getPlayerImageUrl = (league: string, team: string, player: string, filename: string): string =>
  `${ESPN_HEROS_BASE_URL}/${league}/${team}/${player}/${filename}`;

const BG_RESOLUTIONS = ['1920x2400', '2000x2818', '3840x982', '3840x1280', '3840x2160'];

export const getLeagueBackgrounds = (league: string): Record<string, string> =>
  Object.fromEntries(BG_RESOLUTIONS.map(res => [res, `${ESPN_HEROS_BASE_URL}/${league}/backgrounds/${res}.png`]));

export const getLeagueLogoUrl = (league: string): string => `${ESPN_HEROS_BASE_URL}/${league}/logo.png`;
